import React from "react";
import PropTypes from "prop-types";

const SortDirectionIcon = ({ asc, visible }) => {
  SortDirectionIcon.propTypes = {
    asc: PropTypes.bool,
    visible: PropTypes.bool,
  };
  return (
    <i
      className={
        (asc ? "fa fa-caret-up" : "fa fa-caret-down") +
        (visible ? " visible" : " hidden") +
        " sort__i"
      }
    ></i>
  );
};

export default SortDirectionIcon;
